import {ComponentType} from 'react';

import {PersonalAreaTabs} from '~/shared/consts/personalArea';
import Payments from '~/personalArea/components/Sections/Payments';
import MyBenefits from '~/personalArea/components/Sections/MyBenefits';
import MyOrders from '~/personalArea/components/Sections/MyOrders';
import Settings from '~/personalArea/components/Sections/Settings/Settings';
import PersonalArea from '~/personalArea/components/Sections/PersonalArea';
import {trackEvent} from '~/shared/services/analytics';

export const DEFAULT_SECTION = 'personalArea';

export const sections: Record<string, {
  id: keyof typeof sections;
  title: string;
  b2bTitle?: string;
  query: string | null;
  onClick?: () => void;
  component: ComponentType<{isMinLargeMobile?: boolean}>;
  showForCompanyUserOnDesktop?: boolean;
}> = {
  [PersonalAreaTabs.PERSONAL_AREA]: {
    id: PersonalAreaTabs.PERSONAL_AREA,
    title: 'personal_area_page_personal_area_tab',
    query: null,
    onClick: () => trackEvent('personalArea_click'),
    component: PersonalArea,
  },
  [PersonalAreaTabs.MY_ORDERS]: {
    id: PersonalAreaTabs.MY_ORDERS,
    title: 'personal_area_page_my_orders_tab',
    b2bTitle: 'charges_report_2',
    query: 'my-orders',
    onClick: () => trackEvent('myOrdersArea_click'),
    component: MyOrders,
    showForCompanyUserOnDesktop: true,
  },
  [PersonalAreaTabs.PAYMENTS]: {
    id: PersonalAreaTabs.PAYMENTS,
    title: 'personal_area_page_payments_tab',
    query: 'payments',
    onClick: () => trackEvent('paymentMethods_click'),
    component: Payments,
    showForCompanyUserOnDesktop: true,
  },
  [PersonalAreaTabs.MY_BENEFITS]: {
    id: PersonalAreaTabs.MY_BENEFITS,
    title: 'personal_area_page_my_benefits_tab',
    query: 'my-benefits',
    onClick: () => trackEvent('myBenefits_click'),
    component: MyBenefits,
  },
  [PersonalAreaTabs.SETTINGS]: {
    id: PersonalAreaTabs.SETTINGS,
    title: 'personal_area_page_settings_tab',
    query: 'settings',
    onClick: () => trackEvent('settings_click'),
    component: Settings,
  },
};
